import { AppThunk } from '../../../store/rootReducer';
import { exactDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { isRoughlyEqual } from '../../utils/math';
import * as updateActions from '../actions/update.actions';
import { updateSelector } from '../selectors/update.selectors';
import { wavesEntitiesSelector } from '../selectors/wave.selectors';
import { Wave, WaveId } from '../types/wave.type';
import { getUpdatedWave } from '../utils/wave.util';
import { addWave } from './add-wave.thunk';

export const updateWave = (): AppThunk => async (dispatch, getState) => {
  const delineation = wavesEntitiesSelector(getState());
  const update = updateSelector(getState());
  const ecgDuration = exactDurationSelector(getState());

  if (update.updateMode == null) {
    return;
  }

  const getWaveToUpdate = (waveId: WaveId): Wave | null => {
    const baseWave = delineation[waveId];
    if (baseWave == null) {
      return null;
    }

    const linkedWave = baseWave.link?.waveId
      ? delineation[baseWave.link?.waveId]
      : undefined;
    const wave = getUpdatedWave(baseWave, update, ecgDuration, linkedWave);
    const { onset, offset } = wave;
    const waveIsTooSmall = isRoughlyEqual(onset, offset);

    if (waveIsTooSmall) {
      return null;
    }

    return wave;
  };

  const wave = getWaveToUpdate(update.id);

  if (wave == null) {
    return;
  }

  dispatch(updateActions.stop({ meta: { history: false } }));
  dispatch(addWave(wave));

  if (wave.link != null) {
    const linkedWave = getWaveToUpdate(wave.link.waveId);

    if (linkedWave == null) {
      return;
    }

    dispatch(addWave(linkedWave));
  }
};
